import debounce from 'lodash/debounce';

/**
 * Create a redux middleware function that debounces specified
 *
 *
 * @param {array} actionTypes - An array of actions types to debounce
 * @param {number} [wait=0] - Time to wait before executing action batch
 * @returns {function} - middleware function
 */
export default (actionTypes, wait = 0) => {
  const actionQueue = {};
  const debouncedDispatch = {};
  const DEBOUNCE_ACTION = {};

  const dispatch = (store, key) => {
    // disable batchActions due to form validation error
    // store.dispatch(batchActions(actionQueue[key]));
    // TODO: update form initialization, too much actions
    actionQueue[key].forEach((action) => {
      setTimeout(
        () =>
          store.dispatch({
            ...action,
            meta: {
              ...action.meta,
              skipBatch: true,
            },
          }),
        0,
      );
    });

    actionQueue[key] = [];
  };

  const debounceAction = (store, action) => {
    actionQueue[action.type].push(action);
    return debouncedDispatch[action.type](store, action.type);
  };

  actionTypes.forEach((type) => {
    DEBOUNCE_ACTION[type] = true;
    actionQueue[type] = [];
    debouncedDispatch[type] = debounce(dispatch, wait);
  });

  return (store) => (next) => (action) => {
    return DEBOUNCE_ACTION[action.type] && !action.meta.skipBatch
      ? debounceAction(store, action)
      : next(action);
  };
};
